import React, { useContext } from "react";
import { HotelContext } from "../context/hotel";
import AddToHomeScreen from '@ideasio/add-to-homescreen-react';

const InstallPrompt = () => {
  const { data: { id: hotelId, name: hotelName } } = useContext(HotelContext);

  return false;
  
  return (<AddToHomeScreen
    appId={`ViCo::${hotelId}_-_add-homescreen`}
    displayPace={5}       // Every 5 minutes 
    lifespan={45}         // Show for 45 seconds
    maxDisplayCount={3}
    mustShowCustomPrompt={true}
    customPromptContent={{
      src: "https://cdn-dev.vicomanager.com/assets/logo_vico_small.jpg",
      title: `Install ${hotelName} app?`,
      installMsg: "Install",
      cancelMsg: "Not Now",
    }} 
    customPromptPlatformDependencies={{
      "iphone": {
        targetUrl: undefined,
        showClasses: ["iphone-wrapper", "animated", "fadeIn", "d-block"],
        images: [
          {
            src: "/images/addToHomeScreen/iphone.png",
            alt: "Tap the Share Icon and select Add to home screen entry"
          }
        ],
        action: {
          ok: "Ok",
          cancel: "Cancel",
          guidanceCancel: "Dismiss"
        }
      }
    }}
    />);
};

export default InstallPrompt;
